const userType = {
    "startUp":0,
    "investor":1,
    "partner":2
};
const dealTypes={
    0:"Start-up Equity",
    1:"Debt",
    2:"Mergers And Aquisitions"
}
const  formatDate = (dateString)=> {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

module.exports={
    dealTypes,
    userType,
    formatDate
}